import Http from "./http";

export const updateEnrollmentAgreementAPI = (payload, options) => {
  return Http.post("admin/campaign/enrollment-agreement/update", payload, options);
};

